import { Component, ElementRef, Input, ViewChild, inject } from '@angular/core';
import { NormalizedPoint } from '../../../../../models/chat.models';
import { RegionChatSelectionStore } from './region-chat-selection.store';

/** Read-only spotlight for an area review or a restored chat source. */
@Component({
  selector: 'app-region-chat-surface',
  templateUrl: './region-chat-surface.component.html',
  styleUrls: ['./region-chat-surface.component.scss'],
})
export class RegionChatSurfaceComponent {
  readonly store = inject(RegionChatSelectionStore);

  @Input() canvasWidth = 0;
  @Input() canvasHeight = 0;
  @Input() canvasOffsetX = 0;
  @Input() canvasOffsetY = 0;

  @ViewChild('surfaceEl') surfaceEl?: ElementRef<HTMLDivElement>;
  /** Apply live CSS transform during gestures, matching the other Preview overlays (Issue #1489). */
  setGestureTransform(transform: string, transformOrigin: string, transition: string): void {
    const el = this.surfaceEl?.nativeElement;
    if (!el) return;
    el.style.transformOrigin = transformOrigin;
    el.style.transition = transition;
    el.style.transform = transform;
  }

  get outlinePath(): string {
    return this.pathFor(this.store.displayPolygon, true);
  }

  get restoredPath(): string {
    return this.pathFor(this.store.restoredDisplayPolygon, true);
  }

  pathFor(points: NormalizedPoint[], closed: boolean): string {
    if (!points.length) return '';
    const commands = points.map(
      (point, index) =>
        `${index === 0 ? 'M' : 'L'}${(point.x * this.canvasWidth).toFixed(2)} ${(point.y * this.canvasHeight).toFixed(2)}`
    );
    return commands.join(' ') + (closed ? ' Z' : '');
  }
}
